import { createApp, defineAsyncComponent } from 'vue';
import './PodcastBlock.scss';

const podcastPlayers = [...document.querySelectorAll('[data-podcast-player]')];

if (podcastPlayers) {
    podcastPlayers.forEach((item) => {
        const app = createApp({
            name: 'PodcastPlayerBlockApp',
        });
        app.component('podcast-player-block', defineAsyncComponent(
            () => import(/* webpackChunkName: "podcast-player-block" */ './Components/PodcastPlayerBlock.vue')
        ));
        app.mount(item);
    });
}